import config from '../../config'
import axios from 'axios'

const { geoserverURL } = config.geoserver


export function getWorkspaces() {
  return axios
    .get(`${geoserverURL}/rest/workspaces.json`)
    .then(mapDataFn)
    .then(({workspaces: { workspace }}) => workspace)
}


// DataStores
export function getDataStores(workspace) {
  return axios
    .get(`${geoserverURL}/rest/workspaces/${workspace}/datastores.json`)
    .then(({data}) => data)
    .then(({dataStores}) => dataStores ? dataStores.dataStore : [])
}

export function getFeatureTypesFromDataStore(workspace, dataStore) {
  return axios
    .get(`${geoserverURL}/rest/workspaces/${workspace}/datastores/${dataStore}/featuretypes.json`)
    .then(({data}) => data)
    .then(({featureTypes}) => featureTypes ? featureTypes.featureType : [])
}

export async function getLayersFromDataStore(workspace, dataStore) {
  const featureTypes = await getFeatureTypesFromDataStore(workspace, dataStore)

  const promises = featureTypes.map(({name}) => 
    axios.get(`${geoserverURL}/rest/workspaces/${workspace}/datastores/${dataStore}/featuretypes/${name}.json`)
      .then(({data}) => data)
      .then(({featureType}) => featureType)
  )

  return Promise.all(promises)
}

// Coverages
export function getCoverageStores(workspace) {
  return axios
    .get(`${geoserverURL}/rest/workspaces/${workspace}/coveragestores.json`)
    .then(({data}) => data)
    .then(({coverageStores}) => coverageStores ? coverageStores.coverageStore : [])
}

export function getCoveragesFromCoverageStore(workspace, coverageStore) {
  return axios
    .get(`${geoserverURL}/rest/workspaces/${workspace}/coveragestores/${coverageStore}/coverages.json`)
    .then(({data}) => data)
    .then(({coverages}) => coverages ? coverages.coverage : [])
}

export async function getLayersFromCoverageStore(workspace, coverageStore) {
  const coverages = await getCoveragesFromCoverageStore(workspace, coverageStore)
  
  const promises = (coverages || []).map(({name}) => 
    axios.get(`${geoserverURL}/rest/workspaces/${workspace}/coveragestores/${coverageStore}/coverages/${name}.json`)
      .then(({data}) => data)
      .then(({coverage}) => coverage)
  )

  return Promise.all(promises)
}


// Obtener todas las capas dentro de DataStores y CoverageStores de un Workspace
export async function getLayersFromWorkspace(workspace) {
  const dataStores = (await getDataStores(workspace)).map(({name}) => name)
  const coverageStores = (await getCoverageStores(workspace)).map(({name}) => name)
  
  const promisesDS = dataStores.map(dataStore => getLayersFromDataStore(workspace, dataStore))
  const promisesCS = coverageStores.map(coverageStore => getLayersFromCoverageStore(workspace, coverageStore))

  const [LayersDS, LayersCS] = await Promise.all([
    Promise.all(promisesDS),
    Promise.all(promisesCS)
  ])

  return {
    LayersCS: LayersCS.reduce((a, b) => a.concat(b), []),
    LayersDS: LayersDS.reduce((a, b) => a.concat(b), [])
  }
}

export function getOrderedLayersOf(AllLayers, keyName) {
  const { LayersCS, LayersDS } = AllLayers

  return LayersCS
    .concat(LayersDS)
    .filter(l => l.name.startsWith(keyName))
    // .sort(sortFunction)
}

export function getIndicadoresNames(AllLayers) {
  const { LayersCS } = AllLayers
  const names = new Set([])

  for(const layer of LayersCS) {
    const { name } = layer
    const isIndicador = /^[a-z]+_(anual|mensual|trimestral)/.test(name);

    if(isIndicador) {
      const [indicador] = name.split('_')
      names.add(indicador)
    }
  }

  return [...names]
}


// (async function test() {
//   const AllLayers = await getLayersFromWorkspace(geoserverWorkspace)

//   const LayersTemperatura = getOrderedLayersOf(AllLayers, 'temperatura')
//   const LayersVegetacion  = getOrderedLayersOf(AllLayers, 'vegetacion')
//   const LayersBeneficios  = getOrderedLayersOf(AllLayers, 'beneficios')

//   console.log('LayersTemperatura', LayersTemperatura)

//   console.log('LayersVegetación', LayersVegetacion)

//   console.log('LayersBeneficios', LayersBeneficios)

// })()


// WEBPACK FOOTER //
// ./src/api/gsrest/index.js